import { render, staticRenderFns } from "./CoinIcon.vue?vue&type=template&id=5d8c6c8b&"
import script from "./CoinIcon.vue?vue&type=script&lang=js&"
export * from "./CoinIcon.vue?vue&type=script&lang=js&"
import style0 from "./CoinIcon.vue?vue&type=style&index=0&id=5d8c6c8b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports